/** Desktop chapter field and menu are half the toolbar, wider only when a title does not fit. */
export const CHAPTER_MENU_HALF = 0.5;

/** Matches the Tailwind `sm` breakpoint used by the toolbar. */
export const CHAPTER_MENU_DESKTOP_QUERY = '(min-width: 640px)';

/** Popover padding (`p-2`) plus the borders and scrollbar that sit inside the set width. */
const CHAPTER_LIST_CHROME_PX = 16 + 2 + 2 + 6;

export function chapterMenuWidth(half: number, contentWidth: number, limit: number) {
  if (contentWidth <= half) return half;
  return Math.min(contentWidth, limit);
}

export function chapterListWidth(rowWidth: number) {
  return rowWidth + CHAPTER_LIST_CHROME_PX;
}
